<template>
  <div class="case-detail-gene-variant-database-dailog dialog col-block">
    <div class="title-container row-block">
      <div
        class="title"
        v-html="[
          $t('DIALOG.caseDetailGeneVariantDatabase.___title'),
          (tabOptions.length === 1) ? tabOptions[0].title : null
        ].filter(x => x).join('-')"
      ></div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div :style="{ height: '10px' }"></div>
    <div class="data-container col-block" :style="{ flex: 1 }">
      <template v-if="tabOptions.length > 1">
        <div class="data-tab-list-container row-block">
          <div class="data-tab-list-block row-block">
            <div class="data-tab-field col-block width-full" :class="{ active: option.value === tab }" v-for="(option, oindex) in tabOptions" :key="oindex" @click="e => tab = option.value">
              <div class="data-tab-container center-block">
                <div class="data-tab-block row-block">
                  <div class="data-tab-title">{{ option.title }}</div>
                </div>
              </div>
            </div>
          </div>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div :style="{ height: '20px' }"></div>
      </template>
      <div class="data-content-container col-block width-full" :style="{ flex: 1 }">
        <template v-if="tab === 'clinvar'">
          <geneClinvarData
            :param="param"
            @changeModal="data => $emit('changeModal', data)"
          ></geneClinvarData>
        </template>
        <template v-else-if="tab === 'mastermind'">
          <geneMastermindData
            :param="param"
            @changeModal="data => $emit('changeModal', data)"
          ></geneMastermindData>
        </template>
        <template v-if="tab === 'mitomap'">
          <geneMitomapData
            v-if="tabOptions.some(option => option.value === 'mitomap')"
            :param="param"
            @changeModal="data => $emit('changeModal', data)"
          ></geneMitomapData>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import geneClinvarData from '../caseDetail/geneClinvarData.vue'
import geneMastermindData from '../caseDetail/geneMastermindData.vue'
import geneMitomapData from '../caseDetail/geneMitomapData.vue'

export default {
  components: {
    geneClinvarData,
    geneMastermindData,
    geneMitomapData
  },
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      tab: this.param.tab || 'clinvar'
    }
  },
  computed: {
    gene () {
      return this.param.gene || {}
    },
    // static
    tabOptions () {
      let tabOptions = [
        {
          title: this.$t('DIALOG.caseDetailGeneVariantDatabase.tab.title.___clinvar'),
          value: 'clinvar'
        },
        {
          title: this.$t('DIALOG.caseDetailGeneVariantDatabase.tab.title.___mastermind'),
          value: 'mastermind'
        },
        {
          title: this.$t('DIALOG.caseDetailGeneVariantDatabase.tab.title.___MITOMAP'),
          value: 'mitomap',
          display: (this.gene.SYMBOL || '').startsWith('MT-')
        }
      ].filter(option => (option.display !== false) && (!this.param.tab || (this.param.tab === option.value)))
      let targetTab = tabOptions.find(option => option.value === this.param.tab)
      return targetTab ? [targetTab] : tabOptions
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseDetailGeneVariantDatabase.vue